{
    "FormEngineHttpRequestDatasource": {
        "title": "Http Request",
        "description": "HTTP Request, from which the result is used (expects CSV, YAML or JSON)"
    },
    "mask": {
        "FormEngineHttpRequestDatasource": {
            "description": "Description",
            "url": "Url",
            "method": "Method",
            "authGroupTitle": "Authorization",
            "responseGroupTitle": "Response",
            "sourceType": "Source Type",
            "resultPath": "Result Path",
            "resultPathPlaceholder": "e.g. entries",
            "labelColumn": "Label Column",
            "labelColumnPlaceholder": "e.g. {{$i.Label}}",
            "valueColumn": "Value Column",
            "valueColumnPlaceholder": "e.g. {{$i.Value}}",
            "setup": "Setup",
            "data": "Browse"
        }
    }
}